import Dexie, { Table } from 'dexie';
import type { HabitEntity, TodoEntity, TodoTagEntity } from '../../types/data';

export interface TodoTagMapLocalEntity {
  is_snapshot?: boolean;
  todo_id: string;
  tag_id: string;
  created_at?: string;
  modified_at: string;
  is_deleted: boolean;
}

export interface TodoStockItemLocalEntity {
  id: string;
  todo_id: string;
  stock_id: string;
  is_checked: boolean;
  to_buy?: number | null;
  created_at?: string;
  modified_at: string;
  is_deleted: boolean;
}

export interface HabitTagMapLocalEntity {
  habit_id: string;
  tag_id: string;
  created_at?: string;
  modified_at: string;
  is_deleted: boolean;
}

export interface SyncStateLocalEntity {
  key: string;
  value: string;
  updated_at: string;
}

class TodoLocalDexie extends Dexie {
  todos!: Table<TodoEntity, string>;
  todo_tag_map!: Table<TodoTagMapLocalEntity, [string, string]>;
  todo_stock_items!: Table<TodoStockItemLocalEntity, string>;
  habit_tag_map!: Table<HabitTagMapLocalEntity, [string, string]>;
  todo_tags!: Table<TodoTagEntity, string>;
  habits!: Table<HabitEntity, string>;
  sync_state!: Table<SyncStateLocalEntity, string>;

  constructor() {
    super('mytodoapp_todo_sync');

    this.version(1).stores({
      todos: 'id, start_at, habit_id, modified_at, [modified_at+id], [start_at+id], is_deleted',
      todo_tag_map: '[todo_id+tag_id], todo_id, tag_id, modified_at, [modified_at+todo_id+tag_id], is_deleted',
      todo_stock_items: 'id, todo_id, stock_id, modified_at, [modified_at+id], [todo_id+stock_id], is_deleted',
      todo_tags: 'id, modified_at, [modified_at+id], sort_order, is_deleted',
      habits: 'id, modified_at, [modified_at+id], sort_order, is_deleted',
      sync_state: 'key',
    });

    this.version(2).stores({
      todos: 'id, created_at, start_at, habit_id, modified_at, [modified_at+id], [start_at+id], is_deleted',
      todo_tag_map: '[todo_id+tag_id], todo_id, tag_id, modified_at, [modified_at+todo_id+tag_id], is_deleted',
      todo_stock_items: 'id, todo_id, stock_id, modified_at, [modified_at+id], [todo_id+stock_id], is_deleted',
      todo_tags: 'id, modified_at, [modified_at+id], sort_order, is_deleted',
      habits: 'id, modified_at, [modified_at+id], sort_order, is_deleted',
      sync_state: 'key',
    });

    this.version(3).stores({
      todos: 'id, created_at, start_at, habit_id, modified_at, [modified_at+id], [start_at+id], is_deleted',
      todo_tag_map: '[todo_id+tag_id], todo_id, tag_id, modified_at, [modified_at+todo_id+tag_id], is_deleted',
      habit_tag_map: '[habit_id+tag_id], habit_id, tag_id, modified_at, [modified_at+habit_id+tag_id], is_deleted',
      todo_stock_items: 'id, todo_id, stock_id, modified_at, [modified_at+id], [todo_id+stock_id], is_deleted',
      todo_tags: 'id, modified_at, [modified_at+id], sort_order, is_deleted',
      habits: 'id, modified_at, [modified_at+id], sort_order, is_deleted',
      sync_state: 'key',
    });
  }
}

export const todoLocalDb = new TodoLocalDexie();
